var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { RouterManager } from "./routes/RouterManager";
export var App = function () {
    return (_jsx(Stack, __assign({ direction: "column" }, { children: _jsx(RouterManager, {}) })));
};
